<template>
  <div>
    <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
      <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
        <div id="searchBox">
          <el-form-item label="" prop="xhname">
            <el-input placeholder="请输入型号" v-model="searchForm.xhname" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="source">
            <el-input placeholder="请输入品牌" v-model="searchForm.source" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="company">
            <el-input placeholder="请输入交易商" v-model="searchForm.company" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="title">
            <el-input placeholder="请输入商品名称" v-model="searchForm.title" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
            {{ word }}
            <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button type="primary" size="small" @click="handleSearchBtn" icon="el-icon-search">搜索
          </el-button>
          <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <div class="custom-table search-table">
      <el-table border fit highlight-current-row  :data="list" :row-style="tableRowStyle"
                v-loading="listLoading">
        <el-table-column label="序号" prop="id"></el-table-column>
        <el-table-column label="商品编码" prop="cid" width="120"></el-table-column>
        <el-table-column label="商品名称" prop="title"></el-table-column>
        <el-table-column label="型号" prop="xhname" width="200"></el-table-column>
        <el-table-column label="品牌" prop="source"></el-table-column>
        <el-table-column label="入库/出库数量" prop="number" width="120"></el-table-column>
        <el-table-column label="是否含税" prop="shui">
          <template slot-scope="scope">
            <el-button type="text" :style="scope.row.shui == 'T' ? 'color:green':'color: red'" :icon="scope.row.shui == 'T' ?'el-icon-success':'el-icon-error'" style="font-size: 20px"/>
          </template>
        </el-table-column>
        <el-table-column label="采购价/销售价（含税）" prop="price" width="180"></el-table-column>
        <el-table-column label="产地" prop="address"></el-table-column>
        <el-table-column label="包装" prop="baozhuang"></el-table-column>
        <el-table-column label="入库/出库日期" prop="settime" width="120"></el-table-column>
        <el-table-column label="供应商/客户名称" prop="company" width="300"></el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                     :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                     :page-size="selectPage.pageSize"
                     background
                     layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                     style="margin-top: 14px;margin-bottom:14px"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent, onMounted, reactive, ref } from '@vue/composition-api'
import request from '@/utils/request'


export default defineComponent({
  components: { },
  setup() {
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const list = ref([])
    const listLoading = ref(false)
    const searchFormRef = ref(null)
    const searchForm = reactive({
      title:'',
      xhname:'',
      source:'',
      company:''
    })

    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getAccessHistory()
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getAccessHistory()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getAccessHistory()
    }

    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getAccessHistory()
    }

    onMounted(() => {
      getAccessHistory()
    })


    listLoading.value = true
    const getAccessHistory = () => {
      request({
        url: 'departure_history_list.yy',
        params: selectPage,
        data: searchForm,
        method: 'post'
      }).then((res) => {
        const { code, data, total } = res
        if (code == 200) {
          listLoading.value = false
          list.value = data
          allNum.value = total
        }
      })
    }

    const tableRowStyle = ({ row }) => {
      if (row.col_type == 'T') {
        return { color: 'black' }
      } else {
        return { color: 'red' }
      }
    }

    return {
      searchFormRef,
      showAll,
      allNum,
      selectPage,
      word,
      list,
      searchForm,
      listLoading,
      tableRowStyle,
      pageSizeChange,
      pageCurrentChange,
      closeSearch,
      handleSearchBtn,
      handleResetBtn
    }
  }
})
</script>


